import { Store } from '../../features/store/types/Store'
import { internalApiserverApi } from './internal-apiserver'

export type StoreMutation = Partial<Store> & Pick<Store, 'name' | 'ecosystem'>

const storesApi = internalApiserverApi.enhanceEndpoints({ addTagTypes: ['stores'] }).injectEndpoints({
  endpoints: (builder) => ({
    getInternalStores: builder.query<Store[], void>({
      query: () => 'stores',
      providesTags: ['stores'],
    }),
    saveStore: builder.mutation<Store, StoreMutation>({
      query: (store) => ({ url: 'i/stores', method: store.id ? 'PUT' : 'POST', body: store }),
      invalidatesTags: ['stores'],
    }),
  }),
})

export const { useGetInternalStoresQuery, useSaveStoreMutation } = storesApi
